import * as SearchMaskActions from '../../../../../shared/state-management/actions/searchmask';

import { DbTypeActionMapping } from '../../../../../shared/services/db/db.tokens';
import { type } from './type';


export const XENA_SEARCH_MASK_MAPPING: DbTypeActionMapping = {
	type: type,
	route: `${type}/:id`,
	create: SearchMaskActions.SAVE_SEARCH_MASK_SUCCESS,
	update: SearchMaskActions.UPDATE_SEARCH_MASK_SUCCESS,
	remove: SearchMaskActions.DELETE_SEARCH_MASK_SUCCESS,
	load: SearchMaskActions.LOAD_SEARCH_MASK_SUCCESS,
	db: 'userDB'
};



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/mapping/searchmask/searchmask.mapping.ts